export const DocumentationOptions = [
    { name: 'MissingDocumentationFromStaff', description: 'Missing Documentation From Staff' },
    { name: 'MissingDocumentationFromProvider', description: 'Missing Documentation From Provider' },
    { name: 'IncorrectDocumentation', description: 'Incorrect Documentation' },
    { name: 'DocumentationOnWrongChart', description: 'Documentation On Wrong Chart' },
    { name: 'Other', description: 'Other' },
];
